export const CHECKBOX_TYPE_ALLOWREAD = 'CHECKBOX_TYPE_ALLOWREAD';
export const CHECKBOX_TYPE_ALLOWWRITE = 'CHECKBOX_TYPE_ALLOWWRITE';
export const CHECKBOX_TYPE_PREFERENCES = 'CHECKBOX_TYPE_PREFERENCES';



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/helpers/constants.js